import { manufactureToString } from '@/domains/order/services/manufactureConverter';
import type SettingsInterface from '@/domains/settings/typescript/interfaces/SettingsInterface';
import type SettingsDTOInterface from '@/domains/settings/typescript/interfaces/SettingsDTOInterface';

export default function transformDTOtoSettings(settings: SettingsDTOInterface): SettingsInterface {
    return {
        id: settings.id,
        comment: settings.comment,
        isSanded: settings.sanded,
        isGlued: settings.glued,
        manufacture: manufactureToString(settings.manufacture),
        userId: settings.owner,
    } as SettingsInterface;
}
